/* @flow */

// sushi
export type SushiKind = 1 | 2 | 3 | 4;
export type SushiSubkind = 1 | 2 | 3;
export type Sushi = {| kind: SushiKind, subkind: SushiSubkind |};
export const sushi = {
  eq: (s1: Sushi, s2: Sushi) => s1.kind === s2.kind && s1.subkind === s2.subkind,
  new: (kind: SushiKind, subkind: SushiSubkind) => ({ kind, subkind }),
};

// order
export type Order = (toMatch: Sushi, eaten?: Sushi[]) => boolean;
export const order = {
  forKind: (kind: SushiKind): Order => toMatch => toMatch.kind === kind,
  forSushi: (expected: Sushi): Order => toMatch => sushi.eq(expected, toMatch),
};

// gender
const MALE: '男' = '男';
const FEMALE: '女' = '女';

export type Gender = typeof MALE | typeof FEMALE;
export const gender = { MALE, FEMALE };

// age group
const CHILD: '小学生' = '小学生';
const ADULT: '30代' = '30代';
const MIDDLE_AGE: '50代' = '50代';

export type AgeGroup = typeof CHILD | typeof ADULT | typeof MIDDLE_AGE;
export const ageGroup = { CHILD, ADULT, MIDDLE_AGE };

// customer
export type Customer = {
  gender: Gender,
  ageGroup: AgeGroup,
  age: number,
  kind: 1 | 2 | 3,
  orders: Order[],
};

// conveyor belt
type EmptySlot = { type: 'empty' };
type FilledSlot = { type: 'filled', sushi: Sushi };
type EatenSlot = { type: 'eaten', sushi: Sushi };
export type BeltSlot = EmptySlot | FilledSlot | EatenSlot;
export const beltSlot = {
  empty: { type: 'empty' },
  filled: (sushi: Sushi) => ({ type: 'filled', sushi }),
  eaten: (sushi: Sushi) => ({ type: 'eaten', sushi }),
};
export type Belt = Array<BeltSlot>;

// simulation state
export type SimulationState = {
  t: number,
  belt: Belt,
  eatens: Array<Sushi[]>,
};
